import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=9feaf924&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9feaf924')) {
      api.createRecord('9feaf924', component.options)
    } else {
      api.reload('9feaf924', component.options)
    }
    module.hot.accept("./Logout.vue?vue&type=template&id=9feaf924&", function () {
      api.rerender('9feaf924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/Logout.vue"
export default component.exports